interface IProps {
    className?: string;
}

export const BaseSearchIcon = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.364 1.704a8.806 8.806 0 0 1 10.18 13.78l5.74 5.74a.75.75 0 0 1-1.062 1.06l-5.739-5.74a8.806 8.806 0 1 1-9.12-14.841Zm8.637 13.246a.798.798 0 0 0-.052.052 7.306 7.306 0 1 1 .053-.053Z"
            clipRule="evenodd"
        ></path>
    </svg>
);
